import React, { Component } from "react";
import { Tab, Modal, Button, Icon, Header } from "semantic-ui-react";
import { getpath } from "../actions/get-path";
import { getAction } from "../actions/get-action";
import { genempdrop } from "../services/gendropdown";
import { bindActionCreators } from "redux";
import moment from "moment";
import { app, store } from "../index";
import { connect } from "react-redux";
import { datapop } from "../actions/data-populate";
import {
  grabservice,
  createservice,
  grabserviceredux,
} from "../services/crudservice";
import CreateTNM from "../components/accounting/tnm/createtnm";
import TNMReport from "../components/accounting/tnm/tnmreport";
import TMTable from "../components/accounting/tnm/tmtable";
import MassDelete from "../components/accounting/tnm/massdeltnm";
import EditModal from "../components/accounting/editmodal";
import LaborEntry from "../components/shared-components/timesheet/TimeEntryBuilder";
import { newfeedback } from "../actions/feedback";
class TandM extends Component {
  constructor(props) {
    var lastwedate = moment()
      .endOf("isoWeek")
      .subtract(1, "weeks")
      .format("YYYY-MM-DD");
    var lastweek = {
      key: lastwedate,
      value: lastwedate,
      text: moment(lastwedate).format("MM/DD/YYYY"),
    };
    super(props);
    this.state = {
      tminvparams: [],
      tnms: null,
      unaproved: [],
      laborids: [],
      allSelect: true,
      customers: props.customers,
      matids: [],
      genstartdate: null,
      genenddate: null,
      defaultgenerated: false,
      regen: false,
      lastWeDate: lastwedate,
      weeksAvailable: [lastweek],
    };
  }
  componentDidMount() {
    if (!this.props.tnms.length) {
      grabserviceredux("tmsheets", "tnmReducer");
    }
    if (!this.props.invoices.length) {
      grabserviceredux("invoices", "invoiceReducer");
    }

    this.genweeks();
    store.dispatch(getpath("T&M", "list"));
    this.setState({ activeIndex: this.props.params.tabindex });
    grabservice("tminvparams").then((response) =>
      this.setState({ tminvparams: response })
    );
  }
  componentWillUnmount() {
    this.setState({ tnms: [] });
  }

  componentDidUpdate() {
    this.props.datapop("hradmin", "AccessRequest");
    console.log(this.state.tnms);

    if (this.state.activeIndex !== this.props.params.tabindex) {
      window.location.reload();
    }
    if (
      this.state.lastWeDate &&
      !this.state.tnms &&
      this.state.tminvparams.length &&
      this.props.customers.length
    ) {
      this.gentnm(this.state.lastWeDate);
    }
  }
  genreport(date) {
    return app
      .service("tmsheets")
      .find({ query: { wedate: { $gte: date } } })
      .then((results) => {
        return results;
      });
  }
  genweeks() {
    var weekarray = [];
    app
      .service("tmsheets")
      .get("weeks")
      .then((weekarray) => {
        console.log(weekarray);
        weekarray =  weekarray.map((week) => {
          return {
            key: week,
            value: week,
            text: moment(week).format("MM/DD/YYYY"),
          };
        })
        this.setState({
          weeksAvailable: weekarray
        });
      });
  }
  tnmFormatter(tnms) {
    let customers = Array.from(this.props.customers);
    let t_n_m_s = tnms ? tnms : this.state.tnms;
    t_n_m_s = t_n_m_s.sort(
      (a, b) =>
        a.custnumber - b.custnumber ||
        moment.utc(a.wedate).diff(moment.utc(b.wedate))
    );
    let t_m_s = t_n_m_s.map((tnm) => {
      if (tnm.included) {
        let custindex = customers.findIndex(
          (cust) => cust.custnumber === tnm.custnumber
        );
        let custinfo = Object.assign({}, customers[custindex]);
        tnm = { ...tnm, tmnumber: customers[custindex].nexttmnumber };
        custinfo.nexttmnumber = parseInt(custinfo.nexttmnumber) + 1;
        customers[custindex] = Object.assign({}, custinfo);
      } else {
        tnm = { ...tnm, tmnumber: null };
      }
      return tnm;
    });
    this.setState({ tnms: t_m_s });
  }

  findtmindex(newtnms, entry) {
    let index = newtnms.findIndex(
      (i) =>
        i.workordernumber === entry.workordernumber && i.wedate === entry.wedate
    );
    return index;
  }
  populatestate(tnms) {
    let unaproved = [];
    tnms.map((tnm) => {
      if (tnm.app2ind === null) {
        unaproved.push(tnm);
      }
    });
    this.setState({ unaproved });
  }
  getentrys(weDate, service) {
    if (weDate) {
      if (Array.isArray(weDate) && weDate.length) {
        return app.service(service).find({
          query: {
            tmind: 0,
            wedate: { $in: weDate },
            $sort: {
              wedate: 1,
            },
          },
        });
      } else {
        console.log(weDate);
        return app.service(service).find({
          query: {
            tmind: 0,
            wedate: weDate,
          },
        });
      }
    }
  }
  gentnm(weDate) {
    var newtnmproto = {
      workordernumber: "",
      custnumber: null,
      description: "",
      included: true,
      materialfee: 0,
      createdate: moment().format("YYYY-MM-DD"),
      travelfee: 0,
      notification: null,
      approveind: 1,
      tmnumber: 1,
      amount: 0,
      laborids: [],
      matids: [],
      laborfee: 0,
    };
    var newtms = [];
    var customerarray = Array.from(this.state.customers);

    if (this.props.wods.length) {
      return this.getentrys(weDate, "dailylaborentries")
        .then((response) => {
          console.log("genTNM Response", response)
          // This runs through
          if (response.length) {
            response = response.filter((tnm) => tnm.hours > 0);
            response.map((entry) => {
              let tmindex = newtms.findIndex(
                (tm) =>
                  tm.workordernumber === entry.workordernumber &&
                  tm.wedate === entry.wedate
              );
              entry = {
                ...entry,
                payrate: parseFloat(entry.payrate).toFixed(2),
                charge: parseFloat(entry.payrate).toFixed(2) * entry.hours,
                tmindex: tmindex,
              };
              if (tmindex === -1) {
                let wod = this.props.wods.find(
                  (w) => w.workOrderNbr === entry.workordernumber
                );
                console.log("Entry Workorder Number", entry.workordernumber);
                if (!wod.fixedPrice) {
                  var custindex = customerarray.findIndex(
                    (customer) => customer.custnumber === wod.custnumber
                  );
                  let tempcust = Object.assign({}, customerarray[custindex]);
                  console.log("TempCust", tempcust);
                  let newtm = {
                    ...newtnmproto,
                    workordernumber: entry.workordernumber,
                    custnumber: wod.custnumber,
                    description: wod.description,
                    wedate: entry.wedate,
                    tmnumber: tempcust.nexttmnumber,
                    amount: entry.charge,
                    entrycount: 1,
                    laborfee: entry.charge,
                    laborids: [entry.id],
                  };

                  console.log(wod.custnumber, tempcust.custnumber);

                  newtms = newtms.concat(newtm);
                  tempcust.nexttmnumber += 1;
                  customerarray[custindex] = tempcust;
                  console.log(tempcust.nexttmnumber, this.props.customers);
                }
              } else {
                let patchtnm = newtms[tmindex];
                patchtnm = {
                  ...patchtnm,
                  amount: patchtnm.amount + entry.charge,
                  laborfee: patchtnm.laborfee + entry.charge,
                  laborids: patchtnm.laborids.concat(entry.id),
                };
                newtms[tmindex] = patchtnm;
              }
            });
          }
        })
        .then(() => {
          return this.getentrys(weDate, "dailymaterialentries");
        })
        .then((matentries) => {
          matentries = matentries.data ? matentries.data : matentries;
          if (matentries.length) {
            matentries.map((entry) => {
              let tmindex = newtms.findIndex(
                (tm) =>
                  tm.workordernumber === entry.workordernumber &&
                  tm.wedate === entry.wedate
              );
              let wod = this.props.wods.find(
                (w) => w.workOrderNbr === entry.workordernumber
              );
              let custindex = customerarray.findIndex(
                (param) => param.custnumber === wod.custnumber
              );
              let tempcust = Object.assign({}, customerarray[custindex]);

              let charge = entry.amount;
              if (entry.markuppercent) {
                charge = entry.amount * entry.markuppercent;
              }
              if (tmindex === -1) {
                let windex = this.props.wods.findIndex(
                  (w) => w.workOrderNbr === entry.workordernumber
                );
                let wod = this.props.wods[windex];
                if (!wod.fixedPrice) {
                  var newtm = {
                    ...newtnmproto,
                    workordernumber: entry.workordernumber,
                    custnumber: wod.custnumber,
                    description: wod.description,
                    tmnumber: tempcust.nexttmnumber,
                    wedate: entry.wedate,
                    amount: charge,
                    materialfee: charge,
                    matids: [entry.id],
                  };
                  newtms = newtms.concat(newtm);
                  tempcust.nexttmnumber += 1;
                  customerarray[custindex] = tempcust;
                }
              } else {
                let patchtnm = newtms[tmindex];
                patchtnm = {
                  ...patchtnm,
                  amount: patchtnm.amount + charge,
                  materialfee: patchtnm.materialfee + charge,
                  matids: patchtnm.matids.concat(entry.id),
                };
                newtms[tmindex] = patchtnm;
              }
            });
          }
        })
        .then(() => {
          newtms = newtms.sort(
            (a, b) => a.custnumber - b.custnumber || a.tmnumber - b.tmnumber
          );
          this.setState({
            defaultgenerated: true,
            tnms: newtms,
          });
          // this.tnmFormatter(newtnms);
        });
    }
  }

  handledeleteitems() {
    let deleteservice = app.service(this.state.deleteservice);
    this.state.deletepayload.map((item) => {
      deleteservice.remove(item.id);
    });
  }
  handleDelete(id) {
    app.service("tmsheets").remove(id);
  }
  handleEdit(tnm) {
    this.refs.editmodal.setState({ object: tnm, showeditmodal: true });
  }

  render() {
    const panes = [
      {
        menuItem: "Approve",
        render: () => (
          <CreateTNM
            handleDelete={(id) => {
              this.handleDelete(id);
            }}
            tnms={this.state.tnms}
            lastWeDate={this.state.lastWeDate}
            ref="createtnms"
            reruntnms={() =>
              this.setState({ tnms: [] }, () => {
                this.genweeks();
                this.gentnm(this.state.lastWeDate);
              })
            }
            weeksAvailable={this.state.weeksAvailable}
            handlecreate={(wedate) => {
              this.gentnm(wedate);
              console.log(this.state.laborids);
            }}
            handlepost={(tnms) => {
              var message;
              tnms = tnms.filter((t) => t.included);
              tnms = tnms.map((tnm) => {
                delete tnm.included;
                tnm.laborids.map(({ id }) => id);
                tnm.matids.map(({ id }) => id);
                // console.log("tnm.laborids", tnm.laborids)
                console.log(tnm.matids);
                console.log("TNM", tnm);
                tnm.approveind === this.props.myinfo.empnumber;
                return tnm;
              });
              console.log("TNMS", tnms);
              createservice("tmsheets", tnms, "T & Ms")
                .then(() => {
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((err) => {
                  console.log(err);

                  this.props.newfeedback({
                    color: "red",
                    icon: "cancel",
                    header: "TNMS TNMError",
                    body: err.message,
                  });
                  {
                  }
                });
            }}
            handleEdit={(id) => this.handleEdit(id)}
          >
            <TMTable
              tnms={this.state.tnms}
              allSelect={this.state.allSelect}
              checkall={(newselect) => {
                let newts = this.state.tnms.map((temptm) => {
                  return { ...temptm, included: newselect };
                });
                this.setState({ allSelect: newselect }, () =>
                  this.tnmFormatter(newts)
                );
              }}
              updatelist={(i, checked) => {
                let t_m_s = Array.from(this.state.tnms);
                t_m_s[i].included = checked;
                this.tnmFormatter(t_m_s);
              }}
              create
              tableoptions={["TM Number", "Included"]}
            />
          </CreateTNM>
        ),
      },
      {
        menuItem: "Send T&Ms",
        render: () => (
          <div>
            <p>This is send</p>
            {/*
  <SendTNM
    tnms={this.state.approvedtnms}
    handleDelete={id => {
      this.handleDelete(id);
    }}
    handlesend={tnms => this.props.sendstuff("tnms", tnms)}
    handleEdit={id => this.handleEdit(id)}
  />
  */}
          </div>
        ),
      },
      {
        menuItem: "MoveTime",
        render: () => <LaborEntry movetime />,
      },
      {
        menuItem: "Mass Delete",
        render: () => (
          <MassDelete
            tnms={this.state.tnms}
            handleEdit={(id) => this.handleEdit(id)}
            handleDelete={(id) => {
              this.handleDelete(id);
            }}
          />
        ),
      },
      {
        menuItem: "T&M Report",
        render: () => (
          <TNMReport
            genreport={(date) => this.genreport(date)}
            edittnm={(tnm) => {
              this.refs.editmodal.setState({ tnm: tnm, showModal: true });
              this.handleEdit(tnm);
            }}
            handleDelete={(id) => {
              this.handleDelete(id);
            }}
          />
        ),
      },
    ];
    const tabs = ["approve", "send", "move-time", "massdelete", "report"];
    return (
      <div className="TandM">
        {this.state.tnms ? (
          <Tab
            panes={panes}
            menu={{ secondary: true, pointing: true }}
            defaultActiveIndex={tabs.indexOf(this.props.params.tabindex)}
          />
        ) : (
          <div />
        )}
        <Modal open={this.state.showdeletemodal} basic size="small">
          <Header
            icon="archive"
            content="Are you sure you would like to delete these items?"
          />
          <Modal.Content> "Delete Message"</Modal.Content>
          <Modal.Actions>
            <Button
              basic
              color="red"
              inverted
              onClick={() => this.setState({ showdeletemodal: false })}
            >
              <Icon name="remove" /> No
            </Button>
            <Button
              color="green"
              inverted
              onClick={() => this.handledeleteitems()}
            >
              <Icon name="checkmark" /> Yes
            </Button>
          </Modal.Actions>
        </Modal>
        <EditModal
          type="Time and Materials"
          ref="editmodal"
          approvers={genempdrop(this.props.hradmins)}
          handleUpdate={(tnm) => {
            app.service("tmsheets").update(tnm.id, tnm);
          }}
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    invoices: state.invoices.all,
    tnms: state.tnms.all,
    hradmins: state.employees.hradmins,
    wods: state.workorders.derivitives,
    jobs: state.jobs.assignedjobs,
    customers: state.custinfo.customers,
    dates: state.dates.thisweek,
    myinfo: state.myinfo.employeeinfo,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      newfeedback: newfeedback,
      datapop: datapop,
      getpath: getpath,
      get: getAction,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(TandM);



// WEBPACK FOOTER //
// ./src/containers/TandM.jsx